

import { app } from '../globals/objects'
import { constants } from '../globals/constants'


const Win = {};
    Win.height = $(window).height();
    Win.width = $(window).width();


const getStatus = {};
getStatus.isRTL = (app.$body.hasClass('has-rtl') || app.$body.attr('dir') === 'rtl') ? true : false;
getStatus.isTouch = (("ontouchstart" in document.documentElement)) ? true : false;
getStatus.isMobile = (navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|/i)) ? true : false;
getStatus.asMobile = (Win.width < constants._mobBreak) ? true : false;


// Update on Resize
app.$win.on('resize',function(){
	Win.height = $(window).height();
	Win.width = $(window).width();
	getStatus.asMobile = (Win.width < constants._mobBreak) ? true : false;
});

const hastouch = () => {
    	if (getStatus.isTouch===true) { 
    		app.$body.addClass("has-touch");
    	} else { 
    		app.$body.addClass("no-touch");
    	}
    };

const mobileview = () => {
     	if (getStatus.asMobile===true) { 
     		app.$body.addClass('as-mobile');
     	} else {
     		app.$body.removeClass('as-mobile');
     	}
     };


const browser = () => {
        var isChrome = (navigator.userAgent.indexOf("Chrome") !== -1) ? 1 : 0, 
        isFirefox = (navigator.userAgent.indexOf("Firefox") !== -1) ? 1 : 0,
        isSafari = (navigator.userAgent.indexOf("Safari") !== -1) ? true : false,
        isIE = ((navigator.userAgent.indexOf("MSIE") !== -1 ) || (!!document.documentMode)) ? 1 : 0,
        isEdge = !isIE && !!window.StyleMedia, 
        isOpera = (navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) ? 1 : 0;
        
        if(isChrome) {
            app.$body.addClass('chrome');
        } else if (isFirefox){
            app.$body.addClass('firefox');
        } else if (isIE){
            app.$body.addClass('ie');
        } else if (isEdge){
            app.$body.addClass('edge');
        } else if (isOpera){
            app.$body.addClass('opera');
        } else if (isSafari){
            app.$body.addClass('safari');
        }
    };


export { hastouch, mobileview, browser }
